import { render } from "./Wager.vue?vue&type=template&id=f393c048&scoped=true"
import script from "./Wager.vue?vue&type=script&lang=js"
export * from "./Wager.vue?vue&type=script&lang=js"

import "./Wager.vue?vue&type=style&index=0&id=f393c048&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f393c048"

export default script